export enum CommercialImputationDbStatus {
    Manual = 0,
    GeneratedNotYetValidated = 1,
    Validated = 2,
    Abandoned = 3,
}
